import type { SocialPostRendition } from './social-post-preview-card';
import { postGridRenditions } from './social-post-look-parts';

export const GBP_NETWORK = 'google_business';
export const GBP_CAPTION_LIMIT = 250;
export const GBP_FRAME_ASPECT = 4 / 3;
export const GBP_RENDITION: SocialPostRendition = { mode: 'fit', width: 660, height: 1320 };
export const gbpGridRendition = postGridRenditions(330, 349);

export type GbpLook = 'gbp';
